module.exports = __webpack_public_path__ + "static/media/02-millennials_mobile.4108b7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/02-millennials_mobile.png
// module id = 628
// module chunks = 1